import { Component, Host, Prop, getAssetPath, h } from '@stencil/core';
import { getCompanyLogoSize } from '@utils/imageUtils';
import { SizeVariant } from 'src/types';

@Component({
  tag: 'sportsline-company-logo',
  styleUrl: 'sportsline-company-logo.css',
  shadow: true,
})
export class SportslineCompanyLogo {
  /**
   * The size of the logo. Can be 'small', 'medium', 'large', or 'extra-large'.
   */
  @Prop() size: SizeVariant = 'medium';

  render() {
    return (
      <Host>
        <img
          class={{
            'sportsline-company-logo': true,
            'sportsline-company-logo--small': this.size === 'small',
            'sportsline-company-logo--medium': this.size === 'medium',
            'sportsline-company-logo--large': this.size === 'large',
            'sportsline-company-logo--extra-large': this.size === 'extra-large',
          }}
          height={getCompanyLogoSize(this.size)}
          src={getAssetPath('./assets/images/sportsline-green.svg')}
        />
      </Host>
    );
  }
}
